import { render, staticRenderFns } from "./StrateVideo2.vue?vue&type=template&id=0c4260f7&"
import script from "./StrateVideo2.vue?vue&type=script&lang=js&"
export * from "./StrateVideo2.vue?vue&type=script&lang=js&"
import style0 from "./StrateVideo2.vue?vue&type=style&index=0&lang=stylus&scroped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports